var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTestimonialReviewDoubleQuoteMark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 39,
    viewBox: "0 0 48 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1,
    clipPath: "url(#clip0_47_3447)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.11 2.27001C14.46 2.26001 12.81 2.27001 11.16 2.27001V2.29001C9.30003 2.29001 7.43003 2.25001 5.57003 2.29001C2.50003 2.37001 -0.0999723 5.02001 -0.119972 8.09001C-0.149972 11.62 -0.149974 15.16 -0.109974 18.69C-0.109974 19.39 0.0500271 20.12 0.270027 20.79C0.900027 22.69 2.95003 24.77 6.18003 24.72C8.71003 24.68 11.25 24.71 13.78 24.72C14.61 24.72 14.76 24.93 14.57 25.72C13.72 29.23 11.85 32.03 8.79003 34.02C8.56003 34.17 8.49003 34.57 8.34003 34.86C8.63003 34.94 8.97003 35.16 9.21003 35.08C10.28 34.75 11.36 34.43 12.35 33.93C18.72 30.7 21.88 25.32 22.36 18.34C22.58 15.09 22.41 11.8 22.39 8.53001C22.37 4.85001 19.79 2.29001 16.11 2.26001V2.27001Z",
    fill: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.6701 2.27001C40.0001 2.26001 38.3301 2.27001 36.6501 2.27001C34.8101 2.28001 32.9701 2.24001 31.1301 2.29001C28.0101 2.37001 25.4201 5.02001 25.4001 8.13001C25.3801 11.64 25.3701 15.15 25.4101 18.66C25.4101 19.38 25.5501 20.14 25.8001 20.82C26.7101 23.28 28.8801 24.69 31.7201 24.71C34.2501 24.73 36.7901 24.71 39.3201 24.71C40.0801 24.71 40.2701 24.93 40.1101 25.6C39.2701 29.14 37.4101 31.98 34.3301 33.99C34.0901 34.15 34.0001 34.53 33.8401 34.81C34.1501 34.9 34.5001 35.14 34.7601 35.06C35.8001 34.74 36.8701 34.42 37.8401 33.93C44.2501 30.7 47.4201 25.3 47.8901 18.3C48.1101 15.04 47.9401 11.76 47.9201 8.49001C47.8901 4.85001 45.3201 2.29001 41.6801 2.26001L41.6701 2.27001Z",
    fill: "#1D1D1D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_47_3447"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 39,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestimonialReviewDoubleQuoteMark);
export default __webpack_public_path__ + "static/media/testimonial_review_double_quote_mark.7fe2031e1ba4da8fc806334d24220500.svg";
export { ForwardRef as ReactComponent };